import React, { Component } from "react";
import _ from "lodash";
import { withRedux } from "../hoc";
import {
  StepsToGetQuote,
  Search,
  MainSlider,
  PopularTipsTrends,
  PopularProducts,
  Header
} from "../components";
import { getPagehomeAction } from "../actions/page/home";

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages"),
    page: _.get(state, "page")
  };
};

const actions = {
  getPagehomeAction
};

@withRedux(mapStateToProps, actions)
export default class Home extends Component {
  componentDidMount() {
    this.hideMainHeader();
    this.props.actions.getPagehomeAction();
  }
  componentWillUnmount() {
    this.showMainHeader();
  }
  hideMainHeader = () => {
    document.querySelector(".layout header").style.display = "none";
  };
  showMainHeader = () => {
    document.querySelector(".layout header").style.display = "block";
  };
  render() {
    return (
      <div className="home-page container-wrapper">
        <div className="custom-header">
          <Header />
        </div>
        <div className="slider-block">
          <MainSlider data={_.get(this.props, "page.home.data.image_slide")} />
        </div>
        <div className="search-block">
          <Search.Main />
        </div>
        <div className="content-block">
          <div className="container">
            <div className="tips-trends">
              <PopularTipsTrends />
            </div>
            <div className="popular-products">
              <PopularProducts />
            </div>
          </div>
        </div>
        <div className="steps-quote-block">
          <StepsToGetQuote />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home.js